<app-modal *ngIf="showModal" [modalId]="'add-exemplar'" [modalContentId]="'addExemplarContent'"
  [showCloseAlert]="form.dirty || (intermediateData.length > 0)" [showDoneBtn]="true" [modalSize]="'big'"
  (closeEvent)="onCancel($event)">
  <modal-div class="title-text">
    {{option === 'Exemplar' ? 'Add An ' : 'Add A '}}{{option}}
  </modal-div>

  <modal-div class="body-content">
    <p>Fields marked with an asterisk (<span class="mandatory">*</span>)
      are required.</p>
    <p class="modal--info-txt font-bold" id="addExemplarContent">You are adding {{option}} for following node.</p>
    <div class="jumbotron mx-0" *ngIf="nodeDetails">
      <div class="d-flex col-12" id="Container_{{option}}">
        <pre class="col-max-1 font-2x font-bold mb-0">{{ nodeDetails.human_coding_scheme }}</pre>
        <pre class="col-10 font-2x mb-0" [innerHtml]="nodeDetails.full_statement ? nodeDetails.full_statement : nodeDetails.title"></pre>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-md-7">
          <form [formGroup]="form" method="_post" novalidate=""
            class="ng-untouched ng-pristine ng-valid">
            <div class="exemplar-container">

              <div class="row justify-content-between align-items-center">

                <div class="col-12">

                  <div class="form-row form-group">
                    <label for="title" class="font-bold">{{option}} Title <span class="mandatory"
                        >*</span></label>
                    <input type="text" [formControl]="form.controls['title']" class="form-control font-bold" id="title"
                      (keyup)="checkValidation();onValidateTitle();" (blur)="titleChange()" [(ngModel)]="titleData"
                      required />
                    <div *ngIf="form.controls['title'].touched && !validateTitle" class="error--txt" role="alert">
                      <p class="font-bold m-0 d-flex align-items-center mt-1">
                        <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                        Title is required
                     </p>
                    </div>
                    <p id="titleHelp" class="form-text text-muted text-right w-100" role="note">Add a Title for
                      the {{option}} </p>
                  </div>

                  <div class="form-row form-group">
                    <label for="description" class="font-bold">{{option}} Description</label>
                    <textarea type="text" [formControl]="form.controls['description']" class="form-control font-bold"
                      id="description" (keyup)="checkValidation();onValidateDesc();" rows="2"
                      (blur)="descriptionChange()" [(ngModel)]="descData"></textarea>
                  </div>

                  <div class="form-row form-group">
                    <p class="modal--info-txt w-100 mb-2">Add {{option}} using</p>
                    <div class="custom-control custom-radio custom-control-inline" *ngIf="showUrl === 1">
                      <input checked="" class="custom-control-input" id="url" name="customRadioInline1" type="radio"
                        value="0" (click)="selectedOption($event.target.value)">
                      <label class="custom-control-label" for="url">URL</label>
                    </div>

                    <div class="custom-control custom-radio custom-control-inline">
                      <input checked="" class="custom-control-input" id="uploadFile" name="customRadioInline1"
                        type="radio" value="1" (click)="selectedOption($event.target.value)">
                      <label class="custom-control-label" for="uploadFile">Upload file from desktop</label>
                    </div>

                  </div>

                  <section *ngIf="hasAsset === 1">
                    <app-import-file #importFileComponent (uploadFilesEvent)="onFileUploadEvent($event)"
                      (deleteFileEvent)="onFileDeleteEvent($event)" [disableFileUpload]="true" class="full-width">
                    </app-import-file>
                    <section class="col-12 file-uploaded"></section>
                  </section>

                  <section *ngIf="hasAsset === 0">
                    <div class="form-row form-group">
                      <label for="externalLink" id="externalLinkLabel" class="font-bold">Add URL <span class="mandatory"
                          >*</span></label>
                      <input type="text" [formControl]="form.controls['externalLinkInput']" class="form-control"
                        id="externalLinkInput" (keyup)="validateURL()" required
                        aria-labelledby="externalLinkLabel externalLinkHelp" />
                      <div
                        *ngIf="(form.controls['externalLinkInput'].dirty || form.controls['externalLinkInput'].touched) && form.controls['externalLinkInput'].invalid"
                        class="error--txt" role="alert">
                        <p class="font-bold m-0 d-flex align-items-center mt-1">
                          <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                          Invalid Link
                       </p>
                      </div>
                      <p id="externalLinkHelp" class="form-text text-muted text-right w-100" role="note">Enter
                        the URL you wish to add as an external link</p>
                    </div>

                  </section>
                  <div *ngIf="hasAsset != 0" class="d-flex justify-content-start">
                    <ng-container *ngIf="intermediateData && intermediateData.length>0">
                      <div class="col-7 file-uploaded" role="grid">
                        <!-- start of loop -->
                        <div class="row file-item align-items-center" *ngFor="let obj of intermediateData; let i = index;"
                          role="row">
                          <div class="col-3" role="gridcell">
                            <div class="col file-type text-center" aria-live="polite" aria-atomic="true">
                              <p>{{obj.type|uppercase}}</p>
                            </div>
                          </div>

                          <div class="col-7 file-info pl-0" role="gridcell" aria-live="polite" aria-atomic="true">
                            <p class="font-bold" *ngIf="obj.title">{{obj.title}}</p>
                            <p class="text-truncate" *ngIf="obj.description">{{obj.description}}</p>

                            <ng-container *ngIf="obj.hasAsset ===0">
                              <a href="{{obj.external_node_url}}" target="_blank" rel="noopener"
                                aria-label="Click to preview the URL">{{obj.external_link}}</a>
                            </ng-container>

                            <div class="d-flex" *ngIf="obj.hasAsset ===1">
                              <ul class="col-12 p-0 list-inline mb-0">
                                <li class="list-inline-item max-w-50 text-truncate mr-0">{{obj.asset.name}}</li>
                                <li class="list-inline-item text-truncate"><span
                                    class="bytes">{{formatBytes(obj.asset.size)}}</span></li>
                              </ul>
                            </div>

                            <p class="error--msg" *ngIf="messages[i] && obj.hasAsset ===1" role="alert"
                              aria-live="polite" aria-atomic="true"><span class="sr-only">Error</span> {{messages[i]}}</p>
                          </div>
                          <div class="col">
                            <button class="cursor-pointer btn-icon" aria-label="Delete URL" id="deleteURLBtn"
                              (click)="onIntermediateDel()">
                              <em class="material-icons-outlined cursor-pointer font-4x" aria-hidden="true">delete</em>
                            </button>
                          </div>
                          <!-- end of loop -->
                        </div>

                        <ng-container *ngIf="addLoader">
                          <app-preloader [loaderText]="'Adding '+option+'..'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <p class="mt-4">
                    <button (click)="onAddButton()" class="btn btn-primary"
                      [disabled]="intermediateData.length===0 || !valid"
                      [class.disabled]="intermediateData.length===0 || !valid || addLoader" id="{{option| lowercase}}Btn">{{itemExemplars
                      && itemExemplars.length ? 'Add another ' : 'Add '}}{{option| lowercase}}</button>
                  </p>
                </div>

              </div>
            </div>
          </form>
        </div>

        <aside class="col-md-4 file-panel">
          <div class="row">
            <section class="col-12 file-panel-header">
              <h3 class="mb-0 font-bold"> {{option}}s </h3>
            </section>

            <div class="w-100">
              <div *ngIf="showtext" class="d-flex col-12 exemplar-listing">
                <div class="col-12 text-wrapped px-0 animate__animated animate__fadeIn animate__delay-2s">
                  <p class="mb-0"><span class="title font-bold font-3x">{{listEndingData.title}}</span></p>
                </div>
              </div>
              <ng-container *ngIf="itemExemplars">
                <app-exemplar-details *ngFor="let exemplar of itemExemplars;let $index=index" [exemplarData]="exemplar"
                  [serialNo]="$index" [isRightPanel]="true" (editClicked)="false"
                  (deleteClicked)="onFileDeleteEvent($event)" (previewClicked)="false" (downloadClicked)="false"
                  [showDelete]="true" [option]="option"></app-exemplar-details>
              </ng-container>

            </div>
          </div>
        </aside>
      </div>
    </div>
  </modal-div>
</app-modal>
